module.exports = __webpack_public_path__ + "img/nigh-fog.27adc1b6.jpg";